export const fragenVollmachtAutoverkauf = [
  {
    question: "Brauche ich immer eine Vollmacht für den Autoverkauf?",
    answer: (
      <>
        <p>
          Nur, wenn du nicht selbst beim Verkauf anwesend bist oder jemand
          anders den Verkauf abwickelt.
        </p>
      </>
    ),
  },
  {
    question: "Muss eine Vollmacht notariell beglaubigt werden?",
    answer: (
      <>
        <p>
          Nein, in der Regel reicht eine einfache schriftliche Vollmacht mit
          Unterschrift.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich eine Vollmacht widerrufen?",
    answer: (
      <>
        <p>
          Ja, jederzeit. Der Widerruf sollte schriftlich erfolgen, um
          Missverständnisse zu vermeiden.
        </p>
      </>
    ),
  },
  {
    question:
      "Was passiert, wenn der Bevollmächtigte das Auto ohne Absprache verkauft?",
    answer: (
      <>
        <p>
          Dann haftet er zivilrechtlich – du kannst den Verkauf aber nur schwer
          rückgängig machen. Deshalb nur vertrauenswürdige Personen
          bevollmächtigen.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich Autoeinfachlos eine Vollmacht erteilen?",
    answer: (
      <>
        <p>
          Nein, Autoeinfachlos handelt nicht als Käufer, sondern vermittelt dein
          Fahrzeug an geprüfte Händler – du kannst aber jemandem Vollmacht
          geben, die Übergabe zu übernehmen.
        </p>
      </>
    ),
  },
];
